import { useMemo } from 'react';

type FilterOption = {
  aggregateCount: number;
};

type FilterFacet = {
  name: string;
  selected: boolean;
  aggregateCount: number;
};

type ApprovedFilter = {
  id: string;
};

type Filter = {
  options: FilterOption[];
};

type FilterDropdownHelperProps = {
  id: string;
  filtersFacets: FilterFacet[];
  approvedFiltersProp: ApprovedFilter[];
  filter: Filter;
};

const useFiltersDropdownHelper = ({
  id,
  filtersFacets,
  approvedFiltersProp,
  filter,
}: FilterDropdownHelperProps) => {
  const { approvedFilter, filterFacet } = useMemo(() => {
    const filterFacet = filtersFacets?.find((option) => option.name === id);
    const approvedFilter = approvedFiltersProp?.find((option) => option.id === id);
    return { filterFacet, approvedFilter };
  }, [id, filtersFacets, approvedFiltersProp]);

  const disabledOption = useMemo((): boolean => {
    return !filterFacet?.selected || filterFacet?.aggregateCount > 0;
  }, [filterFacet]);

  const filterOptions = useMemo((): FilterOption[] => {
    return filter.options.filter((option) => option.aggregateCount !== null);
  }, [filter]);

  return {
    option: filterFacet || approvedFilter,
    disabledOption,
    filterOptions,
  };
};

export default useFiltersDropdownHelper;
